import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { PACKAGE_RATE_OBJECT, PACKAGE_RATE_CHANNEL, PATHS } from '../../../../../constants/Define';
import { ListComponent } from "../../../common/component/Index";
import { withTranslation } from "react-i18next";
import { Icon, Tooltip, Menu } from 'antd';
import Ripple from '../../../common/component/Ripple';
import PackageRate from '../../../../../models/PackageRate';
import _, { toArray } from 'lodash';
import './style.less'
import EllipsisText from '../../../common/component/EllipsisText/index';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import Modal from '../../../common/component/Modal';
import moment from 'moment';
import { DATE_TIME_FORMAT, PACKAGE_RATE_DISPLAY_SALE_TYPE } from './../../../../../constants/Define';
import Dropdown from '../../../common/component/Dropdown';
import Input from '../../../common/component/Input';

const ListCols = ['id', 'code', 'name', 'hotel', 'displaySale', 'objectApplyValue', 'channel', 'isActive', 'bookingDatesConfig', 'stayingDatesConfig', 'order', 'reasons'];
const ModelFields = Object.getOwnPropertyNames(new PackageRate());

const objectList = toArray(PACKAGE_RATE_OBJECT.OTHER);
const channelList = toArray(PACKAGE_RATE_CHANNEL.OTHER);
const displaySalteList = toArray(PACKAGE_RATE_DISPLAY_SALE_TYPE);
class PackageRateList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
          isShowConfirmChangeActive: false,
          validation: {},
          confirmStatus: {
            isShow: false,
            isActive: null,
            id: null,
            code: null,
            name: null,
            reasons: "",
          },
          titleItemTable: Func.getTitleTable(
            ListCols,
            ["action"],
            ["id"]
          ),
          modelItem: ModelFields,
          componentTable: {
            code: {
              key: "Code",
              width: 120,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => (
                <HMS.FilterDropdown
                  setSelectedKeys={setSelectedKeys}
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  clearFilters={clearFilters}
                ></HMS.FilterDropdown>
              ),
              filterIcon: (filtered) => (
                <ANT.Icon
                  type="search"
                  style={{ color: filtered ? "#1890ff" : undefined }}
                />
              ),
            },
            name: {
              key: "Name",
              width: 320,
              filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
              }) => (
                <HMS.FilterDropdown
                  setSelectedKeys={setSelectedKeys}
                  selectedKeys={selectedKeys}
                  confirm={confirm}
                  clearFilters={clearFilters}
                ></HMS.FilterDropdown>
              ),
              filterIcon: (filtered) => (
                <ANT.Icon
                  type="search"
                  style={{ color: filtered ? "#1890ff" : undefined }}
                />
              ),
              render: (text) => (
                <EllipsisText
                  title={text}
                  content={text}
                  contentMaxWidth={150}
                  overlayClassName={"max-width-500"}
                  overlayComponent={Tooltip}
                />
              ),
            },
            hotel: {
              width: 170,
            },
            displaySale: {
              key: "displaySale",
              width: 200,
              filters: displaySalteList.map(x=> ({ value: x.value, text: x.label })),
              render: (types) => {
                const text = (types || []).map((id, index) => {
                  const item = displaySalteList.find(x=>x.value === id);
                  return item ? <span>{index > 0 ? <br/> : null}{"+ "}{item?.label}</span> : ""
                });
                return types?.filter(x=>x)?.length ? text : "";
              },
            },
            objectApplyValue: {
              key: "ObjectApplyValue",
              width: 170,
              filters: objectList.map(x=> ({ value: x.value, text: x.label })),
              render: (objs) => {
                const text = (objs || []).map((id, index) => {
                  const item = objectList.find(x=>x.value === id);
                  return item ? <span>{index > 0 ? <br/> : null}{"+ "}{item?.label}</span> : ""
                });
                return objs?.filter(x=>x)?.length ? text : PACKAGE_RATE_OBJECT.ALL.ALL.label;
              },
            },
            channel: {
              key: "Channel",
              width: 170,
              filters: channelList.map(x=> ({ value: x.value, text: x.label })),
              render: (channels) => {
                const text = (channels || []).map((id, index) => {
                  const item = channelList.find(x=>x.value === id);
                  return item ? <span>{index > 0 ? <br/> : null}{"+ "}{item?.label}</span> : "";
                });
                return channels?.filter(x=>x)?.length ? text : PACKAGE_RATE_CHANNEL.ALL.ALL.label;
              },
            },
            bookingDatesConfig: {
              key: "bookingDatesConfig",
              width: 190,
              render: (booking) => {
                const dates = (booking.dateRanges || []).map(x=>x?.dateRange).filter(x=>!!x);
                const startDate = moment.min(dates.map(x=>moment(x?.dateFrom)).filter(x=>x.isValid()));
                const endDate = moment.max(dates.map(x=>moment(x?.dateTo)).filter(x=>x.isValid()));
                return `${startDate.format(DATE_TIME_FORMAT.SHORT_DATE)}~${endDate.format(DATE_TIME_FORMAT.SHORT_DATE)}`;
              }
            },
            stayingDatesConfig: {
              key: "stayingDatesConfig",
              width: 190,
              render: (staying) => {
                const dates = (staying.dateRanges || []).map(x=>x?.dateRange).filter(x=>!!x);
                const startDate = moment.min(dates.map(x=>moment(x?.dateFrom)).filter(x=>x.isValid()));
                const endDate = moment.max(dates.map(x=>moment(x?.dateTo)).filter(x=>x.isValid()));
                return `${startDate.format(DATE_TIME_FORMAT.SHORT_DATE)}~${endDate.format(DATE_TIME_FORMAT.SHORT_DATE)}`;
              }
            },
            isActive: {
              width: 150,
              key: "Status",
              filters: [
                { value: true, text: this.props.t(`item.packageRate.filters.active`) },
                {
                  value: false,
                  text: this.props.t(`item.packageRate.filters.inactive`),
                },
              ],
              render: (isActive, record) => {
                return (
                  <ANT.Switch
                    checkedChildren={this.props.t("item.packageRate.filters.active")}
                    unCheckedChildren={this.props.t(
                      "item.packageRate.filters.inactive"
                    )}
                    checked={isActive}
                    style={{ width: "100%" }}
                    loading={this.props.loadingStatus}
                    onChange={(value) => {
                        this.setState({confirmStatus: {
                          isShow: true,
                          isActive: value,
                          id: record.id,
                          code: record.code,
                          name: record.name
                        }})
                      }
                    }
                  />
                );
              },
            },
            order: {
              width: 80,
              align: 'right',
            },
            reasons: {
              width: 200,
              render: (text) => (
                <EllipsisText
                  title={text}
                  content={text}
                  contentMaxWidth={150}
                  overlayClassName={"max-width-500"}
                  overlayComponent={Tooltip}
                />
              ),
            },
            action: {
              width: 100,
              align: 'center',
              key: 'action',
              fixed: 'right',
              render: (text, record) => this.renderEditComponent(record),
            }
          },
          filters: {},
        };
    }

    componentDidMount() {
    }

    onUpdateActive = (id, data) => {
      this.props.updatePackageRateActive(id, data, this.state.filters);
      this.setState({confirmStatus : { isShow: false }});
    }

    validate = () => {
      const { t } = this.props;
      let validate = {
        required: {},
      };

      if(!this.state.confirmStatus.isActive){
        validate.required.reasons = Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.reasons`)
        );
      }
  
      let valueValidate = {};
      const result = Func.multipleValidate(
        this.state.confirmStatus,
        validate,
        valueValidate
      );
  
      this.setState({ validation: { ...result } });
      return Object.keys(result).length < 1;
    }

    render() {
        const { t, loading, dataList, pagination } = this.props;
        const { titleItemTable, modelItem, componentTable, confirmStatus, validation } = this.state;

        return (
          <>
            <ListComponent
              tableKey="package-rate-list"
              scroll={{ x: 1500 }}
              classChildren="p-0"
              classParent="m-0"
              rowKey={(record, k) => (record.id ? record.id : k)}
              loading={{ spinning: loading, size: "large" }}
              dataSource={Func.getDataSource(dataList || [], modelItem)}
              columns={Func.columnsTable({
                titleTable: titleItemTable,
                component: componentTable,
                itemName: "packageRate",
              })}
              onChange={this.props.onChange}
              pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.defaultCurrent, pageSize: pagination.pageSize }}
            />

            <Modal
              title={t("item.packageRate.confirmTitle")}
              visible={this.state.confirmStatus.isShow}
              width={400}
              onOk={() => {
                  if(this.validate()){
                    this.onUpdateActive(this.state.confirmStatus.id, {
                      status: this.state.confirmStatus.isActive,
                      reason: this.state.confirmStatus.reasons,
                      name: this.state.confirmStatus.name
                    });
                  }
                }
              }
              onCancel={() =>
                this.setState({ confirmStatus: { isShow: false } })
              }
              okText={t("action.confirm")}
              closable={false}
            >
              <Fragment>
                <div>
                  {this.state.confirmStatus.isActive
                    ? t("item.packageRate.confirmChangeToActive")
                    : t("item.packageRate.confirmChangeToInactive")}
                  {` ${this.state.confirmStatus.code} + ${this.state.confirmStatus.name}`}
                </div>
                {
                  !this.state.confirmStatus.isActive && (
                    <div className='mt-2'>
                      <HMS.FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={confirmStatus.reasons}
                        validation={validation.reasons}
                        labelTitle={t(`item.packageRate.reasons`)}
                      >
                        <Input.TextArea
                          rows={2}
                          placeholder=""
                          type={`text`}
                          className="form-control"
                          name="reasons"
                          maxLength={200}
                          onChange={(e) =>
                            this.setState({confirmStatus: {...this.state.confirmStatus, reasons: e.target.value}})
                          }
                          value={confirmStatus.reasons}
                        />
                      </HMS.FormWrapperInputComponent>
                    </div>
                  )
                }
              </Fragment>
            </Modal>
          </>
        );
    }

    renderEditComponent(item) {
      const { t, permissions } = this.props;
      const onRemove = () => {
          const { confirm } = Modal;
          confirm({
              title: t(`item.packageRate.confirmTitle`),
              content: `${t(`item.packageRate.confirmDelete`)} ${item.code} + ${item.name}`,
              okText: t(`action.remove`),
              cancelText: t(`action.cancel`),
              onOk: () => {
                this.props.deletePackageRate && this.props.deletePackageRate(item.id)
              },
          });
      };

      const onClone = (item) => {
        const { confirm } = Modal;
        const { t } = this.props;
        confirm({
            title: t(`item.packageRate.confirmTitle`),
            content: `${t(`item.packageRate.confirmClone`)} ${item.code} + ${item.name}`,
            okText: t(`action.clone`),
            cancelText: t(`action.cancel`),
            onOk: () => {
              this.props.clonePackageRate && this.props.clonePackageRate(item.id)
            }
        });
      };

      return (
          <Dropdown overlay={
              <Menu className="action-menu">
                  {
                      permissions && permissions.allowView && !item.isCanEdit &&
                      <Menu.Item>
                          <Link to={Func.getPathWithParams(PATHS.PACKAGE_RATE.VIEW.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                              <Icon type="eye" className="fs20 mr-1" /> {t(`action.show`)}
                          </Link>
                      </Menu.Item>
                  }
                  {
                      permissions && permissions.allowUpdate && item.isCanEdit &&
                      <Menu.Item>
                          <Link to={Func.getPathWithParams(PATHS.PACKAGE_RATE.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                              <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                          </Link>
                      </Menu.Item>
                  }
                  {
                      permissions && permissions.allowCreate &&
                      <Menu.Item onClick={()=> onClone(item)}>
                          <Icon type="plus-square" className="fs20 mr-1" />{t(`action.clone`)}
                      </Menu.Item>
                  }
                  {
                      permissions && permissions.allowDelete && item.isCanDelete &&
                      <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                  }
              </Menu>
          }>
              <Icon type="more" className="fs20 cursorPointer" />
          </Dropdown>
      )
  }
}

export default withTranslation()(PackageRateList);
